import { h, render, ComponentChild } from 'preact';

import { PlatformUtility } from '../utils/platform-utility';
import { PreactApp } from './preact-app';
import { PropertyPreview } from './components/propertypreview/property-preview.component';

const PREACT_APP_SELECTOR = 'hi-app';
const PROPERTY_PREVIEW_SELECTOR = 'hi-property-preview';

function getSelectorAttribs(namedNodeMap: NamedNodeMap) {
  let attribs = {};

  for (let i = 0; i < namedNodeMap.length; i++) {
    attribs[namedNodeMap[i].name] = namedNodeMap[i].value;
  }

  // console.log('attr', attribs);

  return attribs;
}

export default document.addEventListener('DOMContentLoaded', () => {

  if (PlatformUtility.isOnClient()) {
    // console.log('Running on client');
    
    let targets = document.querySelectorAll(PREACT_APP_SELECTOR);

    targets.forEach((member) => {
      const attributes = getSelectorAttribs(member.attributes);
      let componentVDOM = h(PreactApp, attributes);

      render(componentVDOM, member);
    });

    let propertyPreviewTargets = document.querySelectorAll(PROPERTY_PREVIEW_SELECTOR);
    
    
    propertyPreviewTargets.forEach((member) => {
      const attributes = getSelectorAttribs(member.attributes);
      let previewVDOM = h(PropertyPreview, attributes);
      render(previewVDOM, member);
    });
  }
});